import React from 'react'
import { FiArrowDown, FiArrowUpRight } from 'react-icons/fi'

const KineticWord = ({ word, offset = 0 }) => (
  <span className="kinetic-word" aria-hidden="true">
    {[...word].map((letter, index) => (
      <span
        className="kinetic-letter"
        key={letter + index}
        style={{ '--letter-delay': offset + index * 38 + 'ms' }}
      >
        {letter}
      </span>
    ))}
  </span>
)

export default function Hero() {
  return (
    <section
      id="home"
      aria-labelledby="hero-title"
      className="portfolio-intro relative overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 relative">
        <div className="intro-eyebrow flex items-center justify-between gap-4 font-mono text-[10px] sm:text-xs tracking-[0.16em] uppercase">
          <span className="inline-flex items-center gap-2 text-cream-dim">
            <span className="w-1.5 h-1.5 rounded-full bg-lime" /> Developer &
            curious builder
          </span>
          <span className="text-cream-muted hidden sm:block">
            Oslo, Norway / Portfolio
          </span>
        </div>
        <h1
          id="hero-title"
          className="intro-name font-display font-extrabold tracking-[-0.065em]"
          aria-label="Sakaria Ahmed"
        >
          <KineticWord word="SAKARIA" />
          <span className="intro-second-line">
            <span className="intro-asterisk text-lime" aria-hidden="true">
              ✳
            </span>
            <KineticWord word="AHMED" offset={180} />
          </span>
        </h1>
        <div className="intro-rule" aria-hidden="true" />
        <div className="intro-details grid md:grid-cols-[1.1fr_1fr] gap-7 md:gap-16 pt-7 sm:pt-9">
          <div>
            <p className="font-display text-2xl sm:text-3xl leading-tight tracking-tight text-cream">
              Ideas into code.
              <br />
              <span className="text-cream-dim">Code into working systems.</span>
            </p>
            <div
              className="flex flex-wrap gap-x-5 gap-y-2 mt-6 font-mono text-[11px] text-lime tracking-[0.12em] uppercase"
              aria-label="Focus areas"
            >
              <span>01 / Software</span>
              <span>02 / AI</span>
              <span>03 / Infrastructure</span>
            </div>
          </div>
          <div>
            <p className="text-cream-dim text-base sm:text-lg leading-relaxed max-w-md">
              I build applications, experiment with AI, and run a Linux homelab
              to learn what happens after the code is written.
            </p>
            <div className="flex flex-wrap items-center gap-6 mt-7">
              <a
                href="#projects"
                className="portfolio-button inline-flex items-center justify-center gap-3 rounded-full bg-lime px-6 py-3.5 text-dark font-medium"
              >
                Explore my work <FiArrowDown aria-hidden="true" />
              </a>
              <a
                href="#homelab"
                className="portfolio-text-link inline-flex items-center gap-2 text-sm text-cream"
              >
                Inside the homelab <FiArrowUpRight aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
        <div className="intro-details flex flex-wrap items-center justify-between gap-3 border-t border-edge mt-10 sm:mt-14 pt-5 font-mono text-[10px] sm:text-xs text-cream-muted">
          <span>
            Currently exploring{' '}
            <span className="text-cream-dim">
              Azure · Terraform · Agentic coding
            </span>
          </span>
          <span className="text-cream-dim">AZ-104 study in progress ↗</span>
        </div>
      </div>
    </section>
  )
}
